









































































import { Component, Emit, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { User } from '@/store/models';
import { validationMixin, Vuelidate } from 'vuelidate';
import { TUser, userValidator } from '@/config/validation/user-validator';
import coachService from '@/services/common/coach.service';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';
import coachModule from '@/store/modules/common/coach.module';
import VMessage from '@/components/items/VMessage.vue';
import VDatePicker from '@/components/items/VDatePicker.vue';
import VPasswordInput from '@/components/items/VPasswordInput.vue';
import VPopupResetPassword from '@/components/popup/VPopupResetPassword.vue';
import { dateFilter } from '@/config/filter';
import moment, { now } from 'moment';

@Component({
  name: 'VModalImportData'
})
export default class VModalImportData extends Mixin {
  @Prop({ required: true }) isShowModal?: boolean;
  @Prop({ required: true }) users?: any[];

  public getClass(user: any) {
    if (user['status'] === 'success') return 'text-success';
    if (user['status'] !== 'success') return 'text-danger';
  }
}
